import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { SalesListPage, salesListSortEnum } from "@/modules/user";
import { requireAuthAndPermission } from "@/utils";

const salesListSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(salesListSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/users/sales/")({
  validateSearch: zodValidator(salesListSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Sales"
        description="Manage your sales team members."
      />
      <SalesListPage />
    </>
  )
});
